module.exports = window["wp"]["htmlEntities"];